import { combineReducers } from 'redux';
import { REHYDRATE } from 'redux-persist/constants';
import { changeLanguage } from '../components/Sidebar/actions';
import i18n from '../i18n';

console.log(i18n);
const currentLanguage = (state = i18n.options.fallbackLng[0], action) => {
  if (action.type === changeLanguage.type) {
    return action.payload.lang;
  }

  if (action.type === REHYDRATE) {
    return (action.payload.langs && action.payload.langs.currentLanguage) || state;
  }

  return state;
};


export default combineReducers({
  currentLanguage,
});



// WEBPACK FOOTER //
// ./src/reducers/lang.js